"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getCollection_1 = __importDefault(require("./getCollection"));
exports.default = (composer, defaultLocale, getContentRows) => {
    composer.Query.getFieldNames().map(fieldName => {
        const otc = composer.Query.getFieldOTC(fieldName);
        composer.addResolveMethods({
            Query: {
                [fieldName]: async (_, args, context) => {
                    var _a, _b;
                    return getCollection_1.default({
                        defaultLocale,
                        locale: ((_b = (_a = context) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b["accept-language"]) || "ET",
                        args,
                        typeOtc: otc,
                        getContentRows,
                    });
                },
            },
        });
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkUmVzb2x2ZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2Ntcy9zY2hlbWEvcmVzb2x2ZXJzL2FkZFJlc29sdmVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLG9FQUFpRTtBQUVqRSxrQkFBZSxDQUNiLFFBQTZCLEVBQzdCLGFBQXFCLEVBQ3JCLGNBQStCLEVBQy9CLEVBQUU7SUFDRixRQUFRLENBQUMsS0FBSyxDQUFDLGFBQWEsRUFBRSxDQUFDLEdBQUcsQ0FBQyxTQUFTLENBQUMsRUFBRTtRQUM3QyxNQUFNLEdBQUcsR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUNsRCxRQUFRLENBQUMsaUJBQWlCLENBQUM7WUFDekIsS0FBSyxFQUFFO2dCQUNMLENBQUMsU0FBUyxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLEVBQUU7O29CQUN0QyxPQUFPLHVCQUFhLENBQUM7d0JBQ25CLGFBQWE7d0JBQ2IsTUFBTSxFQUFFLGFBQUEsT0FBTywwQ0FBRSxPQUFPLDBDQUFHLGlCQUFpQixNQUFLLElBQUk7d0JBQ3JELElBQUk7d0JBQ0osT0FBTyxFQUFFLEdBQUc7d0JBQ1osY0FBYztxQkFDZixDQUFDLENBQUM7Z0JBQ0wsQ0FBQzthQUNGO1NBQ0YsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==